import { AxiosResponse } from 'axios'
import { User } from 'src/types/user'

import axios from '../../axios'

export const resendInitialPassword = async (
  email: string
): Promise<AxiosResponse> => {
  await axios.get(`/api/csrf-cookie`)
  const response = await axios
    .post<{ user: User }>(`/api/resend-initial-password`, {
      email,
    })
    .catch((error) => {
      return error.response
    })

  return response
}
